<template>
  <v-row>
    <v-col v-if="idJugador !== 0" cols="12" md="4">
      <v-text-field v-model="jugadorName" color="gold" item-color="gold" label="Jugador" readonly />
    </v-col>
    <v-col v-else cols="12" md="4">
      <validation-provider ref="contratoForm" v-slot="{ errors }" name="Jugador" rules="required">
        <v-autocomplete v-model="jugadorSelected" color="gold" item-color="gold" label="Jugador" return-object
                  :items="jugadores" :error-messages="errors" item-text="fullName"
        >
          <template v-slot:item="{ attrs, item, on }">
            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="item.fullName" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      </validation-provider>
    </v-col>
    <v-col v-if="mode !== 'new' && tipoContratoSelected !== null" cols="12" md="3">
      <v-text-field v-model="tipoContratoSelected.descripcion" color="gold" item-color="gold" label="Tipo de contrato" readonly />
    </v-col>
    <v-col v-else cols="12" md="4">
      <validation-provider v-slot="{ errors }" name="tipo de contrato" rules="required">
        <v-select v-model="tipoContratoSelected" color="gold" item-color="gold" label="Tipo de contrato" return-object item-text="descripcion" :items="tipos_contrato" :error-messages="errors">
          <template v-slot:item="{ attrs, item, on }">
            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="item.descripcion" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </v-col>
    <!--Contratos -->
    <v-col v-if="tipoContratoSelected !== null" cols="12" md="3">
      <validation-provider v-if="tipoContratoSelected.club_sn || tipoContratoSelected.es_prestamo_sn" v-slot="{ errors }" name="Club" rules="required">
        <v-text-field v-if="mode !== 'new'" :value="inClub.descripcion" color="gold" item-color="gold" label="Club" readonly />
        <v-autocomplete v-else v-model="clubSelected" color="gold" item-color="gold" label="Club" item-value="id" item-text="descripcion" :items="clubes" :error-messages="errors">
          <template v-slot:item="{ attrs, item, on }">
            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="item.descripcion" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      </validation-provider>
      <validation-provider v-if="tipoContratoSelected.sponsor_sn" v-slot="{ errors }" name="sponsors" rules="required">
        <v-text-field v-if="mode !== 'new'" :value="inSponsor.descripcion" color="gold" item-color="gold" label="Sponsor" readonly />
        <v-select v-else v-model="sponsorSelected" color="gold" item-color="gold" label="Sponsors" item-value="id" item-text="descripcion" :items="sponsors" :error-messages="errors">
          <template v-slot:item="{ attrs, item, on }">
            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="item.descripcion" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </v-col>
    <v-col v-if="(tipoContratoSelected !== null) && (mode == 'new') && (tipoContratoSelected.club_sn || tipoContratoSelected.es_prestamo_sn)" cols="12" md="1" class="pt-5">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn x-small dark fab color="success" v-bind="attrs" v-on="on" @click="clubDialog = true">
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
        </template>
        <span>Agregar Club</span>
      </v-tooltip>
    </v-col>
    <v-dialog v-model="clubDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Nuevo club</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <validation-observer v-slot="{ handleSubmit }">
              <form id="altaclub" @submit.prevent="handleSubmit(validateForm)">
                <v-row align="center" justify="center">
                  <v-col cols="12">
                    <validation-provider v-slot="{ errors }" name="club" rules="max:20">
                      <v-text-field v-model="club.descripcion" color="#ac8a2e" :error-messages="errors" name="input-6-1" label="Club" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12">
                    <validation-provider v-slot="{ errors }" name="liga" rules="required">
                      <v-select v-model="club.liga_id" color="#ac8a2e" :error-messages="errors" label="Liga" item-value="id" item-text="descripcion" :items="ligas">
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="secondary elevation-4 white--text" class="v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.descripcion" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
                    </validation-provider>
                  </v-col>
                </v-row>
              </form>
            </validation-observer>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="clubDialog = false">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text form="altaclub" type="submit" @click="clubDialog = false">
                Guardar
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name: 'ParametrosInicContrato',
    props: {
      jugador: {
        type: Object,
        required: false,
        default: null,
      },
      tipoContrato: {
        type: Object,
        required: false,
        default: null,
      },
      idJugador: {
        type: Number,
        required: true,
        default: 0,
      },
      mode: {
        type: String,
        required: true,
      },
      inClub: {
        type: Object,
        required: false,
        default: null,
      },
      inSponsor: {
        type: Object,
        required: false,
        default: null,
      },
      inRepresentacion: {
        type: Object,
        required: false,
        default: null,
      },
      idContratoPadre: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    data () {
      return {
        jugadores: [],
        tipos_contrato: [],
        sponsors: [],
        clubes: [],
        ligas: [],
        sponsorSelected: this.inSponsor,
        clubSelected: this.inClub,
        contRepreSelected: this.inRepresentacion,
        tipoContratoSelected: this.tipoContrato,
        jugadorSelected: null,
        contRepreSelectedAux: null,
        clubDialog: false,
        club: {

        },
      }
    },
    computed: {
      jugadorName () {
        return (this.jugadorSelected !== null) ? this.jugadorSelected.fullName : ''
      },
    },
    watch: {
      jugadorSelected (val) {
        this.getTiposContratos()
        if (this.mode === 'new') this.tipoContratoSelected = null
        this.$emit('jSelected', val)
      },
      tipoContrato (val) {
        this.tipoContratoSelected = val
      },
      sponsorSelected (val) {
        this.$emit('sSelected', val)
      },
      clubSelected (val) {
        this.$emit('cSelected', val)
      },
      contRepreSelected (val) {
        this.$emit('crSelected', val)
      },
      tipoContratoSelected (val) {
        if (this.mode === 'new') {
          this.sponsorSelected = null
          this.clubSelected = null
          this.contRepreSelected = null
          this.tipoContratoSelected = val
        }
        if (val !== null) this.$emit('tcSelected', val)
        if (val.es_prestamo_sn) { this.contRepreSelected = this.contRepreSelectedAux }
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      contRepreText (item) {
        return 'Valido hasta: ' + item.valido_hasta
      },
      loadData () {
        if (this.idJugador === 0) {
          this.getJugadores()
        }
        if (this.idJugador !== 0) {
          this.getJugador()
        }
        this.getClubes()
        this.getLigas()
        this.getSponsors()
      },
      getJugador () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador/' + this.idJugador }).then(response => { this.jugadorSelected = response })
      },
      getJugadores () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador' }).then(response => { this.jugadores = response })
      },
      getClubes () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/club_get' }).then(response => { this.clubes = response })
      },
      getLigas () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/liga_get' }).then(response => { this.ligas = response })
      },
      getSponsors () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/sponsor_get' }).then(response => { this.sponsors = response })
      },
      getTiposContratos () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/tipo_contrato_get' }).then(response => {
          this.tipos_contrato = response
          const aux = this.tipos_contrato.find(element => element.es_prestamo_sn === 1)
          if (this.mode !== 'prestamo') {
            const index = this.tipos_contrato.indexOf(aux)
            this.tipos_contrato.splice(index, 1)
            this.puedePrestamo(aux)
          } else {
            this.tipos_contrato = []
            this.puedePrestamo(aux)
            this.tipoContratoSelected = aux
          }
        })
      },
      setClub () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/club_get/' + this.club.descripcion + '/' + this.club.liga_id }).then(response => { this.clubSelected = response.id })
      },
      puedePrestamo (contratoPrestamo) {
        this.$store.dispatch('axiosMod/getData', { url: '/api/contrato_profesional/' + this.jugadorSelected.id }).then(response => {
          if (response !== '') {
            this.tipos_contrato.push(contratoPrestamo)
            this.contRepreSelectedAux = response
          }
        })
      },
      validateForm (scope) {
        this.enviarClub()
      },
      enviarClub: async function () {
        const method = 'post'
        await this.$http({
          method: method,
          url: '/api/club_agregar',
          data: {
            ...this.club,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de club exitosa'] })
          this.getClubes()
          this.setClub()
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        })
      },
    },
  }
</script>
